import classNames from 'classnames';
import {
  View,
  InfoMessageBlock,
  MessageItem,
  Modal,
  Messaging,
} from 'components';
import { observer } from 'mobx-react-lite';
import { useNotices, usePublicAccount } from 'state';
import { useState } from 'react';
import styles from './NoticesMessagesScreen.module.scss';

/**
 * NoticesMessagesScreen
 *
 * @return {JSX.Element}
 */
const NoticesMessagesScreen = ({ className }) => {
  const {
    data: { profileUid },
  } = usePublicAccount();
  const {
    mapped: { messagingDataByTenancy },
  } = useNotices();
  const [openMessages, setOpenMessages] = useState(null);

  const handleClick = (idx) => () => setOpenMessages(idx);

  const handleCLose = () => setOpenMessages(null);

  return (
    <View
      className={classNames(
        styles.NoticesMessagesScreen,
        className,
        `${NoticesMessagesScreen.displayName}`
      )}
    >
      {messagingDataByTenancy.length ? (
        <>
          {messagingDataByTenancy.map((item, idx) => {
            const lastDayData = item.data[item.data.length - 1];
            const viewMessage =
              lastDayData.items[lastDayData.items.length - 1].data;
            const unread =
              profileUid !== viewMessage.messageFromUid &&
              !viewMessage.hasViewed;

            return (
              <MessageItem
                key={item.tenancyUid}
                message={viewMessage.messageText}
                type={viewMessage.noticeType}
                subject={viewMessage.noticeTitle}
                onClick={handleClick(idx)}
                hasViewed={!unread}
                isImage={viewMessage.isImage}
                noWrap
              />
            );
          })}
          {typeof openMessages === 'number' ? (
            <Modal onClose={handleCLose} scrollContainer noPadding fullHeight>
              <Messaging
                message={messagingDataByTenancy[openMessages]}
                onClose={handleCLose}
              />
            </Modal>
          ) : null}
        </>
      ) : (
        <InfoMessageBlock
          title="No Messages"
          description="When a tenancy is set up a messaging channel will appear here"
        />
      )}
    </View>
  );
};

NoticesMessagesScreen.displayName = 'NoticesMessagesScreen';

export default observer(NoticesMessagesScreen);
